import styled from 'styled-components';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { SizeAddiFontXSmall } from '@addi/foundation/dist/web/sizes';
import { FontAddiWeightBold } from '@addi/foundation/dist/web/fonts';
import { ColorAddiBackgroundWhite, ColorAddiFontOverDark, ColorAddiFontPrimary, ColorAddiCompThreeLighten1, ColorAddiWhite, ColorAddiPrimaryActive, } from '@addi/foundation/dist/web/colors';
import { Caption, Subtitle } from '../typographies';
export const SubNavBar = styled.div `
  position: relative;
`;
export const SubNavBarShop = styled.div `
  width: 100%;
  background: ${ColorAddiBackgroundWhite};
  position: relative;
  box-shadow: 0px 0px 15px 0px rgba(0, 0, 0, 0.1);
  padding: 10px;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
  z-index: 2;
  box-sizing: border-box;
`;
export const Subtitles = styled(Subtitle) `
  margin: 0;
`;
export const SubNavBarShopInfo = styled.div `
  background: ${ColorAddiBackgroundWhite};
  color: ${ColorAddiFontPrimary};
`;
export const SubNavBarAllyLogoWrapper = styled.div `
  width: 45px;
  height: 45px;
  border-radius: 10px;
  overflow: hidden;
`;
export const SubNavBarAllyLogo = styled.img `
  width: 45px;
  height: 45px;
`;
export const SubNavBarSelectedLoanProposal = styled.div `
  margin-top: -15px;
  position: relative;
  border-radius: 10px;
  box-shadow: 0 0 5px 0 rgba(0, 0, 0, 0.1);
  display: flex;
  justify-content: space-between;
  padding: 20px 10px 5px 10px;
  background: ${ColorAddiCompThreeLighten1};
  color: ${ColorAddiFontOverDark};
  z-index: 1;
  font-size: ${SizeAddiFontXSmall};
  font-weight: ${FontAddiWeightBold};
  text-align: bottom;
`;
export const BadgeCheckIcon = styled(FontAwesomeIcon) `
  height: 1.2rem !important;
  color: ${ColorAddiCompThreeLighten1};
  margin-right: 5px;
`;
export const AllyDiscountAmountInfo = styled(Caption) `
  text-decoration: line-through;
  opacity: 0.5;
`;
export const AllyDiscountPercentage = styled(Caption) `
  &&& {
    color: ${ColorAddiWhite};
    background-color: ${ColorAddiPrimaryActive};
  }
  white-space: nowrap;
  margin: 5px;
  letter-spacing: 0.01em;
  padding: 0 3px;
`;
//# sourceMappingURL=infoBar.Styles.js.map